{
  "home": {
    "heroStop": "STOP HUMAN SAFARI",
    "heroSave": "RED KHERSON",
    "heroTitle1": "Civile mennesker",
    "heroTitle2": "Er Ikke skydeskiver",
    "heroDate": "13., 14. december",
    "worldwideRally": "Verdens&shy;omspændende demonstration",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "Siden sommeren 2024 har russiske styrker brugt små droner til at jage, dræbe og terrorisere civile på gaderne i Kherson og andre frontlinje-byer i Ukraine. <bold>Menneske-safari skal stoppes. DU kan gøre en forskel </bold>Deltag sammen med tusinder verden over for at kræve, at denne krigsforbrydelse ophører.",
    "seeGallery": "Se plakater fra hele verden",
    "comingSoon": "Lokationer kommer snart",
    "december": "december",
    "dec": "dec.",
    "october": "oktober",
    "oct": "okt.",
    "september": "september",
    "sep": "sep.",
    "schedule9": "9.",
    "schedule10": "10.",
    "schedule11": "11.",
    "schedule12": "12.",
    "schedule13": "13.",
    "schedule14": "14.",
    "schedule16": "16.",
    "schedule18": "18.",
    "schedule20": "20.",
    "schedule1": "1.",
    "schedule2": "2.",
    "schedule3": "3.",
    "schedule4": "4.",
    "schedule5": "5.",
    "schedule25": "25.",
    "schedule26": "26.",
    "schedule27": "27.",
    "schedule28": "28.",
    "schedule29": "29.",
    "schedule30": "30.",
    "schedule31": "31.",
    "scheduleTBC": "Bekræfter dato...",
    "recommendationsTitle": "Anbefalinger fra FN-Kommissionen",
    "recommendationsRussia": "Kommissionen opfordrer kraftigt Den Russiske Føderation til :",
    "rusRec1": "(a) Straks at stoppe droneangreb rettet mod civile og civile objekter",
    "rusRec2": "(b) Straks at stoppe med at terrorisere civilbefolkningen",
    "rusRec3": "(c) At holde alle gerningsmænd involveret i droneangreb mod civile ansvarlige",
    "recommendationsUNStates": "Kommissionen opfordrer andre stater samt regionale og internationale organisationer til:",
    "statesRec1": "(a) At bidrage både økonomisk og med teknisk rådgivning til Ukraines regering og civilsamfundsorganisationer med det formål at yde omfattende støtte til ofre og deres familier;",
    "statesRec2": "(b) At tredjelande, hvor deporterede personer fra de besatte områder befinder sig, samarbejder med de ukrainske konsulære myndigheder om at yde den nødvendige støtte til disse personer.",
    "reference": "Kilde",
    "linkUN": "FN-Kommissionen: Ruslands “menneske-safari” i Ukraine er en forbrydelse mod menneskeheden",
    "linkGuidelines": "FN-Retningslinjer",
    "linkWiki": "Wikipedia"
  },
  "resources": {
    "title": "Vigtige kilder",
    "linkLibraryTitle": "Link-bibliotek",
    "linkLibraryDesc": "200 artikler, rapporter, interviews, øjenvidneberetninger og mediedækning",
    "humanSafariMapTitle": "Tochnyis Human Safari-kort",
    "humanSafariMapDesc": "Et interaktivt kort over Human Safari-angreb i Kherson, samlet ud fra åbne kilder som lokale myndigheders indberetninger og angrebsvideoer, som Tochnyi-teamet har geolokaliseret.",
    "truthHoundsTitle": "Truth Hounds-rapport",
    "truthHoundsDesc": "Killzone: Hvordan russiske droner ødelægger Dnipro-flodens højre bred",
    "hrwTitle": "Human Rights Watch-rapport om droneangreb i Kherson",
    "hrwDesc": "HRW-rapport",
    "unReportsTitle": "FN’s Menneskerettighedsråds rapporter",
    "report1": "FN-rapport #1",
    "report3": "FN-rapport #3",
    "guidelines": "FN-Retningslinjer",
    "wikipediaTitle": "Wikipedia",
    "english": "Engelsk",
    "french": "Fransk",
    "documentaryTitle": "Dokumentar",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13. - 14. dec.",
    "eyewitnesses": "vidner",
    "rallies": "fotos",
    "help": "deokkuperet Kherson",
    "leftBank": "besat Kherson",
    "action": "dec. '25",
    "oleshky": "global demo - Oleshky",
    "menu": "Menu"
  },
  "leftBank": {
    "pageTitle": "Dronebelejring",
    "para1": "En akut humanitær nødsituation rammer 6.000 civile, der er fanget under en dronebelejring i det besatte Oleshky, Hola Prystan, Stara Zburivka og Nova Zburivka - den besatte Kherson-region. I Oleshky 1.200 - 2.000. Besættelsesmagten er forpligtet til at støtte dem - i stedet bruges de som menneskelige skjolde af de russiske styrker, der gemmer sig bag denne befolkning, mens de udfører Human Safari-angreb på den modsatte bred. Ukrainske myndigheder og humanitære aktører rapporterer om systematisk hindring af evakuering og humanitær adgang.",
    "para2": "De civile mangler mad, vand, lægehjælp, medicin, elektricitet, gas og kommunikation. Vejene er kraftigt minerede, og droneaktivitet begrænser bevægelsesfriheden. Ingen køretøjer har kunnet komme ind eller ud siden den 26. maj. Brændstof- og fødevareforsyningerne er næsten opbrugt.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Video: »Kherson and Oleshky: Witnessing Genocide« (12 min)",
    "meidasArticle": "Artikel: »The Kherson Region: How Russia Uses Civilians as a Tool of War« (5 min læsning)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Artikel: »Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate« (7 min læsning)",
    "tellPost": "og fortæl andre om Dronebelejringen",
    "callToHelp": "DU kan hjælpe. Sådan gør du",
    "donateIntro": "Disse initiativer yder målrettet hjælp med stor effekt direkte til mennesker, der er flygtet fra Oleshky, eller, hvor det er muligt, sidder fanget der.",
    "signTitle": "Skriv under",
    "signSub": "underskriftsindsamlinger",
    "petitionBy": "af {{name}}",
    "petitions": {
      "euParliament": "Europa-Parlamentet – Andragende nr. 1439/2026 om oprettelse af en humanitær evakueringskorridor for civile, der sidder fanget under belejring i det russisk besatte Oleshky i Ukraine",
      "ukParliament": "Det britiske parlament – Arbejd for en britisk ledet humanitær hjælpekorridor til Oleshky i Ukraine"
    },
    "publicActionLead": "Sæt fokus på dronebelejringen, dér hvor du er.",
    "organiseAction": "Organiser en aktion.",
    "policyBody": "De ukrainske myndigheder er i konsultationer med Den Internationale Røde Kors-Komité om at oprette en humanitær evakueringskorridor fra de besatte bosættelser i Kherson-regionen og sikre humanitær adgang for mad, vand, medicin, brændstof og lægehjælp. I begyndelsen af juni er der ingen fungerende evakueringskorridor eller vedvarende mekanisme for humanitær adgang.",
    "documentaryTitle": "Oleshky, kort dokumentarfilm",
    "downloadTitle": "Download",
    "downloadSub": "grafik"
  },
  "footer": {
    "addCityText": "For at tilføje din by, send en e-mail til: ",
    "organiseText": "Tilføj din demo - kontakt os:",
    "contact": "Kontakt:"
  },
  "byCountry": "vis efter land",
  "byDate": "vis efter dato",
  "countries": {
    "australia": "Australien",
    "austria": "Østrig",
    "bulgaria": "Bulgarien",
    "canada": "Canada",
    "czechia": "Tjekkiet",
    "denmark": "Danmark",
    "estonia": "Estland",
    "finland": "Finland",
    "france": "Frankrig",
    "georgia": "Georgien",
    "germany": "Tyskland",
    "hungary": "Ungarn",
    "italy": "Italien",
    "japan": "Japan",
    "mexico": "Mexico",
    "netherlands": "Nederlandene",
    "norway": "Norge",
    "poland": "Polen",
    "romania": "Rumænien",
    "spain": "Spanien",
    "sweden": "Sverige",
    "southAfrica": "Sydafrika",
    "ukraine": "Ukraine",
    "unitedKingdom": "Storbritannien",
    "usa": "USA",
    "ireland": "Irland",
    "belgium": "Belgien"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "Spanien",
      "time": "Alicante - Spanien, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcelona",
      "country": "Spanien",
      "time": "Barcelona - Spanien, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "USA",
      "time": "Berkeley - USA, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlin",
      "country": "Tyskland",
      "time": "Berlin - Tyskland, 12:00",
      "location": "Tempelhofer Feld, indgang Leinstr./hjørne af Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "USA",
      "time": "Bettendorf - USA, 17:30 - Filmvisning",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - Filmvisning",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "Storbritannien",
      "time": "Birmingham - Storbritannien, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge Str.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Tyskland",
      "time": "Bonn - Tyskland, 14:00 - 16:00",
      "location": "Poststraße, foran hovedbanegården",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Bremen",
      "country": "Tyskland",
      "time": "Bremen - Tyskland, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapest",
      "country": "Ungarn",
      "time": "Budapest - Ungarn, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "USA",
      "time": "Chicago - USA, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Constanța",
      "country": "Rumænien",
      "time": "Constanța - Rumænien, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "København",
      "country": "Danmark",
      "time": "København - Danmark, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "USA",
      "time": "Dallas - USA, 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "USA",
      "time": "Denver - USA, 12:00",
      "location": "Colorado Capitol-bygning, vesttrapperne",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Edinburgh",
      "country": "Storbritannien",
      "time": "Edinburgh - Storbritannien, 13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "USA",
      "time": "Fort Worth - USA, 14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Hamburg",
      "country": "Tyskland",
      "time": "Hamburg - Tyskland, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "USA",
      "time": "Houghton, Michigan - USA, 15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finland",
      "time": "Helsinki - Finland, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Japan",
      "time": "Izumo - Japan, 13:00",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Japan",
      "time": "Izumo - Japan",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops",
      "country": "Canada",
      "time": "Kamloops - Canada, 15:00 - 16:00",
      "location": "Rådhuset",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kyiv",
      "country": "Ukraine",
      "time": "Kyiv - Ukraine, 17:00 - 18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Leipzig",
      "country": "Tyskland",
      "time": "Leipzig - Tyskland, 12:00 - 13:00",
      "location": "Willy-Brandt-Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "London",
      "country": "Storbritannien",
      "time": "London - Storbritannien, 18:30 - Filmvisning",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Filmvisning",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Angeles",
      "country": "USA",
      "time": "Los Angeles - USA, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Málaga",
      "country": "Spanien",
      "time": "Málaga - Spanien, 18:00  - Filmvisning",
      "location": "Maydan - Centro Historico Cultural Ukraniano",
      "cleanTime": "18:00 - Filmvisning",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "Storbritannien",
      "time": "Manchester - Storbritannien, 14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Mexico City",
      "country": "Mexico",
      "time": "Mexico City - Mexico, 11:00",
      "location": "Alameda Central. \"Americas\" springvand (mellem Hemiciclo Juárez og Kiosk)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Milano",
      "country": "Italien",
      "time": "Milano - Italien, 15:00",
      "location": "Domkirken i Milano",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "München",
      "country": "Tyskland",
      "time": "München - Tyskland, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Tyskland",
      "time": "Nienburg (Weser) - Tyskland, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Norge",
      "time": "Oslo - Norge, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Sverige",
      "time": "Östersund - Sverige, 11:00 - 14:00",
      "location": "Stortorget (Hovedpladsen)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:30 - 13:30",
      "location": "russiske ambassade",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:00",
      "location": "USAs ambassade",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Paris",
      "country": "Frankrig",
      "time": "Paris - Frankrig, 15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (march)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Plovdiv",
      "country": "Bulgarien",
      "time": "Plovdiv - Bulgarien, 16:00 - 17:00",
      "location": "ved Levski-huset",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Prag",
      "country": "Tjekkiet",
      "time": "Prag - Tjekkiet, 14:00",
      "location": "Palackého Square",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "Sydafrika",
      "time": "Rosendal - Sydafrika, 11:00",
      "location": "kontorer for South African Police Service",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Tenerife",
      "country": "Spanien",
      "time": "San Andrés, Tenerife - Spanien, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "USA",
      "time": "San Diego - USA, 14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "USA",
      "time": "San Francisco - USA, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Tyskland",
      "time": "Schwerin - Tyskland, 19:00 - Filmvisning",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Filmvisning",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "USA",
      "time": "Seattle - USA, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sveti Vlas",
      "country": "Bulgarien",
      "time": "Sveti Vlas - Bulgarien, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sydney",
      "country": "Australien",
      "time": "Sydney - Australien, 14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallinn",
      "country": "Estland",
      "time": "Tallinn - Estland, 15:00 - Filmvisning og rally",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - Filmvisning og rally",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "Spanien",
      "time": "Tarragona - Spanien, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "Haag",
      "country": "Holland",
      "time": "Haag - Holland, 13:00 - 15:00",
      "location": "Foran Fredspaladset / ICC",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tbilisi",
      "country": "Georgien",
      "time": "Tbilisi - Georgien, 21:00",
      "location": "Tbilisi",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Sverige",
      "time": "Tranås - Sverige, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Wien",
      "country": "Østrig",
      "time": "Wien - Østrig, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (ved siden af Stephansdom)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Washington, D.C.",
      "country": "USA",
      "time": "Washington, D.C. - USA, 12:30 - 13:30",
      "location": "The White House",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Polen",
      "time": "Wrocław - Polen, 13:00",
      "location": "Plac Wolności (i retning mod People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "Organiser! For at tilføje din by, send en e-mail til:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Del på {{platform}}",
    "website": "Hjemmeside",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, journalist og filminstruktør, stod i spidsen for den verdensomspændende demonstration og instruerede dokumentarfilmen Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Beskyttelse af civile til gaderne i Kherson — beskytter civile mod drone-angreb.",
      "foodDesc": "Fødevarehjælp.",
      "foodNote": "Skriv »Food for Cherson« som reference, når du donerer."
    },
    "ahs": {
      "name": "Anti Human Safari-projektet",
      "desc": "Dronedetektorer og beskyttelsesveste til frivillige og redningstjenester i Kherson."
    },
    "pageTitle": "Stop Human Safari",
    "sectionIntro": "Siden sommeren 2024 har det russiske militær brugt små droner til at jage, dræbe og terrorisere civile på gaderne i Kherson og andre frontbyer i Ukraine.",
    "sectionIntro2": "Det er en systematisk og bevidst mordkampagne: de russiske droneoperatører lægger åbent optagelserne af deres ofre ud i Telegram-kanaler for at prale. I maj 2025 anerkendte FN Human Safari som en igangværende krigsforbrydelse.",
    "sectionIntro3": "Der bliver gjort for lidt. Human Safari skal stoppes.",
    "sectionIntroBold": "DU kan hjælpe. Her er hvordan",
    "step2Title": "Organiser",
    "step3Title": "Fortæl andre",
    "step3Para": "Brug hashtags",
    "step3ParaPost": "og fortæl andre om Human Safari",
    "instagram": "Instagram",
    "step2Bullet1": "en filmvisning",
    "step2Bullet2": "en offentlig handling",
    "step2Bullet3": "mediedækning",
    "publicActionLead": "Sæt fokus på menneskesafarien, dér hvor du er.",
    "reachOutPre": "Du kan",
    "reachOut": "kontakte os",
    "reachOutPost": "for idéer og ressourcer",
    "newsCoverageLead": "via dine mediekontakter. Fortæl dem om menneskesafarien og om risikoen for alle nuværende og fremtidige konfliktområder.",
    "putInTouchPre": "Du kan også",
    "putInTouch": "sætte os i direkte kontakt",
    "inform": "Informér",
    "informSub": "dig selv og andre",
    "policyTitle": "Politik",
    "policyBody": "Det foreslåede LORA Act (Liability for Operators and Responsible Authorities Act) ville indføre sanktioner i hele ansvarskæden – fra russiske FPV-operatører og befalingsmænd til den øverste militære ledelse samt producenter og leverandører, der muliggør produktion og indsættelse af droner mod civile.",
    "policyHelp": "Kan du hjælpe på det politiske plan?",
    "getInTouch": "Kom i kontakt",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "donate": "Doner",
    "donateIntro": "Disse initiativer yder målrettet hjælp med stor effekt for direkte at beskytte civile i Kherson mod Human Safari.",
    "shareTitle": "Spred budskabet",
    "filmScreening": "Organiser en visning af dokumentarfilmen Kherson Human Safari:",
    "howItStarted": "Sådan begyndte det",
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "Støt dem i at betale for husly og basale fornødenheder til indbyggere i Oleshky."
    }
  },
  "action": {
    "intro": "Vi startede med en verdensomspændende demonstration. Nu kan du:",
    "helpLink": "hjælp her"
  },
  "accounts": {
    "heading": "Beretninger"
  },
  "media": {
    "close": "Luk",
    "view": "Se medie",
    "previous": "Forrige",
    "next": "Næste",
    "andrushenkoCredit": "Oleksandr Andrushenko, fotokorrespondent for mediet Vgoru",
    "khersonPoliceCredit": "fra @khersonpolice",
    "antypenkoCredit": "Ivan Antypenko, fotojournalist fra Kherson",
    "telegramChannelCredit": "delt i den russiske Human Safari-Telegramkanal »fra Mariupol til Karpaterne«",
    "fruitSellerDescription": "Frugtsælger jagtet af en fiberoptisk drone",
    "burntCarDescription": "Udbrændt bil i Kherson",
    "bridgeAttackDescription": "Teenagedreng dræbt af en FPV-drone under en bro i Kherson",
    "busAttackDescription": "Et af mange FPV-droneangreb på offentlig transport",
    "fpvDroneDescription": "FPV-drone på jagt under »Human Safari«",
    "antiDroneNetsDescription": "Gade i Kherson dækket af net mod droner fra »Human Safari«",
    "firefighterDescription": "En brandmand slukker en bil efter et angreb i »Human Safari«; bagved ligger et offer"
  },
  "follow": {
    "title": "Følg",
    "subHumanSafari": "kvalitetskilder, der rapporterer fra Kherson og om Human Safari",
    "subDroneSiege": "kvalitetskilder, der rapporterer fra Kherson og om dronebelejringen",
    "localPress": "lokal ukrainsksproget presse",
    "lang": {
      "english": "engelsk",
      "german": "tysk",
      "ukrainian": "ukrainsk"
    },
    "language": "Sprog: {{list}}",
    "languages": "Sprog: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "Amerikansk journalist og filminstruktør bosat i Kherson, rapporterer for Byline Times og Euromaidan Press; instruktør på dokumentarfilmen Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Chefreporter på den tyske avis Die Welt; rapporterer jævnligt om Human Safari i Kherson."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Skriver Kherson Weekly, en løbende optegnelse over russiske droneangreb på civile i Kherson og landsbyerne omkring."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Uafhængig medieplatform fra Kherson-regionen om livet under angreb og under besættelse."
    },
    "suspilne": {
      "name": "Suspilne Kherson",
      "desc": "Kherson-redaktionen hos Ukraines public service-medie."
    },
    "most": {
      "name": "MOST",
      "desc": "Lokalt nyhedsbureau i Kherson, der dækker byen og regionen."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "STOP DRONE&shy;BELEJRINGEN",
      "heroSave": "RED OLESHKY",
      "worldwideRally": "Verdens&shy;omspændende demo",
      "heroDate": "Oktober",
      "infoText1": "Tusindvis af civile er fanget under dronebelejring i Oleshky, Hola Prystan, Stara Zburivka og Nova Zburivka. Russiske styrker bruger dem som menneskelige skjolde og gemmer sig bag dem for at udføre menneske-safari-droneangreb mod den modsatte bred.",
      "infoText2": "Krisen er akut – der mangler mad, vand, lægehjælp, medicin, elektricitet, gas og kommunikation. Vejene er kraftigt minerede, og droner begrænser al bevægelse. <bold>DU kan hjælpe. Deltag sammen med tusinder verden over for at kræve, at dronebelejringen stopper.</bold>",
      "imageAlt": "En udsultet hund blandt menneskeknogler i det ødelagte Oleshky under en rød himmel fuld af droner, med ordene Stop Russian Drone Siege",
      "demandsTitle": "Vi kræver:",
      "demand1": "sikre og effektive humanitære korridorer til Oleshky og andre berørte lokalsamfund.",
      "demand2": "øjeblikkelig humanitær nødhjælp og bistand til ofrene for Human Safari-angreb.",
      "demand3": "passende sanktioner mod personer og forsyningskæder, der er ansvarlige for angreb rettet mod civile.",
      "demand4": "skridt til at afskrække brugen af små droner til systematisk at angribe og terrorisere civile i Kherson, Ukraine og andre steder.",
      "cities": {
        "edinburgh": {
          "city": "Edinburgh",
          "country": "Storbritannien",
          "time": "Edinburgh - Storbritannien, 14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "Storbritannien",
          "time": "Birmingham - Storbritannien, 14:00 - 16:00",
          "location": "Over for Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Wien",
          "country": "Østrig",
          "time": "Wien - Østrig, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "München",
          "country": "Tyskland",
          "time": "München - Tyskland, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "London",
          "country": "Storbritannien",
          "time": "London - Storbritannien, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Manchester",
          "country": "Storbritannien",
          "time": "Manchester - Storbritannien, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sydney",
          "country": "Australien",
          "time": "Sydney - Australien, 14:00",
          "location": "Sydney Town Hall",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Paris",
          "country": "Frankrig",
          "time": "Paris - Frankrig, 15:30 - 18:30",
          "location": "Fra Saint Volodymyr-kirken til Place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Paris",
          "country": "Frankrig",
          "time": "Paris - Frankrig, 18:00",
          "location": "Rambuteau metrostation",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lyon",
          "country": "Frankrig",
          "time": "Lyon - Frankrig, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublin",
          "country": "Irland",
          "time": "Dublin - Irland, 13:00",
          "location": "The GPO (hovedpostkontoret)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Bruxelles",
          "country": "Belgien",
          "time": "Bruxelles - Belgien, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Bruxelles (Schuman-rundkørslen)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Canada",
          "time": "Ottawa - Canada, 12:30 - 13:30",
          "location": "Den russiske ambassade, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "Frankrig",
          "time": "Nantes - Frankrig, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Gdańsk",
          "country": "Polen",
          "time": "Gdańsk - Polen, 18:30 - 19:30",
          "location": "Długi Targ, ved Neptun-springvandet",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Dresden",
          "country": "Tyskland",
          "time": "Dresden - Tyskland, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Málaga",
          "country": "Spanien",
          "time": "Málaga - Spanien, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "London",
          "country": "Storbritannien",
          "time": "London - Storbritannien, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Plovdiv",
          "country": "Bulgarien",
          "time": "Plovdiv - Bulgarien, 17:00",
          "location": "Hovedgaden (Glavnata), ved Kamenitza-trappen / »Together«-skiltet",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapest",
          "country": "Ungarn",
          "time": "Budapest - Ungarn, 17:00 - 20:00",
          "location": "Szent István tér (Sankt Stefans Plads)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "London",
          "country": "Storbritannien",
          "time": "London - Storbritannien, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "London",
          "country": "Storbritannien",
          "time": "London - Storbritannien, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Hamburg",
          "country": "Tyskland",
          "time": "Hamburg - Tyskland, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, ud for bro 1, 20359 Hamburg",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kiel",
          "country": "Tyskland",
          "time": "Kiel - Tyskland, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Norge",
          "time": "Oslo - Norge",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Leipzig",
          "country": "Tyskland",
          "time": "Leipzig - Tyskland, 17:00 - 18:00",
          "location": "Hovedbanegården (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "London",
          "country": "Storbritannien",
          "time": "London - Storbritannien, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "London",
          "country": "Storbritannien",
          "time": "London - Storbritannien, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublin",
          "country": "Irland",
          "time": "Dublin - Irland, 13:00",
          "location": "The GPO (hovedpostkontoret)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublin",
          "country": "Irland",
          "time": "Dublin - Irland, 14:00",
          "location": "The GPO (hovedpostkontoret)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "Frankrig",
          "time": "Nantes - Frankrig, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Stop den russiske dronebelejring",
      "posterNoRoadOut": "Vejene ind og ud af Oleshky er blokeret",
      "posterHumanitarianCatastrophe": "Oleshky. En humanitær katastrofe under besættelse",
      "seeGallery": "Se / download plakater"
    },
    "artBy": "Kunst: {{name}}",
    "downloadPoster": "Download plakat",
    "reel": {
      "download": "Download video (MP4)"
    },
    "addDemo": {
      "title": "tilføj din demo",
      "where": "hvor: by",
      "contact": "e-mail/nummer",
      "message": "besked: hvem du repræsenterer, din demo er bekræftet eller undervejs, link til online-opslag, andre detaljer",
      "submit": "Send",
      "sending": "Sender…",
      "thanks": "Tak! Vi kontakter dig.",
      "error": "Noget gik galt. Prøv igen.",
      "contactInvalid": "Indtast en gyldig e-mail eller et telefonnummer med landekode (f.eks. +45 20 12 34 56).",
      "date": "dato",
      "time": "starttid (lokal)",
      "whereInvalid": "Indtast navnet på en by, f.eks. København eller Kyiv, Ukraine.",
      "datePlaceholder": "dato: dd/mm"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Stop dronebelejringen — Red Oleshky | Demoer verden over",
      "description": "Russiske droner belejrer tusindvis af civile i det besatte Oleshky i Ukraine, afskåret fra mad, vand og medicin. Find en demo nær dig og kræv sikker passage."
    },
    "leftBank": {
      "title": "Dronebelejringen af Oleshky og den besatte Kherson-region",
      "description": "Tusindvis af civile er fanget under en russisk dronebelejring i det besatte Oleshky, Hola Prystan og nærliggende landsbyer. Læs hvad der sker, og hvordan du kan hjælpe."
    },
    "help": {
      "title": "Stop Human Safari — Russiske droner jager civile i Kherson",
      "description": "Russiske droner jager civile i Kherson, Ukraine. Læs om krigsforbrydelsen Human Safari, og hvordan du kan hjælpe med at stoppe den."
    },
    "action": {
      "title": "Verdensomspændende demonstration december 2025 — Stop Human Safari",
      "description": "Fotos, plakater og steder fra den verdensomspændende demonstration i december 2025 mod russiske droneangreb på civile i Kherson, Ukraine."
    },
    "rallies": {
      "title": "Fotos fra demonstrationer — Stop Human Safari",
      "description": "Fotos fra demonstrationer verden over mod russiske droneangreb på civile i Kherson, Ukraine."
    },
    "resources": {
      "title": "Human Safari — Rapporter, artikler og vidneudsagn",
      "description": "Rapporter, artikler, interviews og vidneudsagn om russiske droneangreb på civile i Kherson, Ukraine."
    },
    "reel": {
      "title": "Red Oleshky — Demovideo",
      "description": "Video fra de verdensomspændende demoer »Red Oleshky«, oktober 2026."
    }
  }
}
